// Flags des fonctionnalités non (encore) implémentées.
// Source de vérité unique pour masquer dans l'UI ce qui n'est pas réellement branché.
// Repasser un flag à `true` une fois la fonctionnalité opérationnelle.
// Cf. NON-IMPLEMENTE.md à la racine du projet.

// Notifications : aucune notif n'est jamais envoyée (ni push navigateur, ni scheduler
// back). Masque la cloche 🔔 de l'en-tête et neutralise l'écran de permission de
// l'onboarding (qui conserve la création de compte, mais sans le discours « notifs »).
export const SHOW_NOTIFICATIONS = false;

// Canaux de contact (Email / Chat en direct / FAQ) non cliquables sur la page Support.
export const SHOW_CONTACT_CHANNELS = false;

// Abonnement / facturation : pas encore de vraie logique de paiement.
export const SHOW_SUBSCRIPTION = false;
